import { useEffect, useMemo } from 'react';
import '../styles/GeneralStyles.css';

const CalendlyStep = ({prevStep, nextStep, formData}) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Construir la URL con los parámetros de prefill
  const calendlyUrl = useMemo(() => {
    const baseUrl = 'https://calendly.com/tressor/reunion-compromiso';
    const params = [];

    // Agregar nombre completo si existe
    if (formData?.firstName || formData?.lastName) {
      const fullName = `${formData.firstName || ''} ${formData.lastName || ''}`.trim();
      if (fullName) {
        params.push(`name=${encodeURIComponent(fullName)}`);
      }
    }

    // Agregar email si existe
    if (formData?.email) {
      params.push(`email=${encodeURIComponent(formData.email)}`);
    }

    return params.length > 0 ? `${baseUrl}?${params.join('&')}` : baseUrl;
  }, [formData]);

  return (
    <div className="container-large">
      <div className="wrapp-calandly">
        <div className="column-content-calendly">
          <div className="text-n-options">
                <h2>Agenda una llamada con nosotros</h2>
                <p>Selecciona el horario que mejor te convenga para discutir los detalles de tu anillo.</p>
          </div>
          <div 
            className="calendly-inline-widget" 
            data-url={calendlyUrl}
            style={{ minWidth: '320px', height: '700px' }} 
          />
        </div>
      </div>
    </div>
  );
};

export default CalendlyStep;
